<template>
    <div class="container">
        <div class="header">
            <div class="header-left">
                <el-button type="primary" @click="loadData(1)">刷新</el-button>
                <!-- <el-button type="primary" @click="exportOpen()">导出Excel</el-button> -->
            </div>
            <div class="header-right" v-if="pageMap.filter">
                <el-date-picker v-model="monthRange" type="monthrange" format="yyyyMM" value-format="yyyyMM" range-separator="至" start-placeholder="开始月份" end-placeholder="结束月份" style="margin-right: 10px;" @change="monthRangeChange">
                </el-date-picker>
                <el-input v-for="item in pageMap.filter" v-model="filterParams[item.prop]"
                    :placeholder="'请输入' + item.label" class="header-input" @change="loadData(1)"></el-input>
                <el-button type="primary" @click="loadData(1)">搜索</el-button>
            </div>
        </div>
        <el-table :data="records" border style="width: 100%">
            <el-table-column prop="inventoryCommonMonth" label="月份" width="90"></el-table-column>
            <el-table-column prop="inventoryCustomerName" label="公司名称" width="300">
                <template slot-scope="scope">
                    <span class="td-copy" @click="copyClick(scope.row.inventoryCustomerName)">{{ scope.row.inventoryCustomerName }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="inventoryCustomerPerson" label="负责人">
                <template slot-scope="scope">
                    <span class="td-copy" @click="copyClick(scope.row.inventoryCustomerPerson)">{{ scope.row.inventoryCustomerPerson }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="inventoryCategoryName" label="项目">
                <template slot-scope="scope">
                    <span class="td-copy" @click="copyClick(scope.row.inventoryCategoryName)">{{ scope.row.inventoryCategoryName }}</span>
                </template>
            </el-table-column>
            <!-- 实际费用 -->
            <el-table-column label="贸易">
                <el-table-column prop="inventoryAccountActualTradeAmount" label="开票金额">
                    <template slot-scope="scope">
                    <span class="td-copy" @click="copyClick(scope.row.inventoryAccountActualTradeAmount)">{{ scope.row.inventoryAccountActualTradeAmount }}</span>
                </template>
                </el-table-column>
                <el-table-column prop="inventoryPaymentActualTradeService" label="服务费">
                    <template slot-scope="scope">
                    <span class="td-copy" @click="copyClick(scope.row.inventoryPaymentActualTradeService)">{{ scope.row.inventoryPaymentActualTradeService }}</span>
                </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="过夜">
                <el-table-column prop="inventoryPaymentActualNightAmount" label="金额">
                    <template slot-scope="scope">
                    <span class="td-copy" @click="copyClick(scope.row.inventoryPaymentActualNightAmount)">{{ scope.row.inventoryPaymentActualNightAmount }}</span>
                </template>
                </el-table-column>
                <el-table-column prop="inventoryPaymentPlanNightRate" label="费率">
                    <template slot-scope="scope">
                    <span class="td-copy" @click="copyClick(scope.row.inventoryPaymentPlanNightRate)">{{ scope.row.inventoryPaymentPlanNightRate }}</span>
                </template>
                </el-table-column>
                <el-table-column prop="inventoryPaymentActualNightFee" label="过夜费">
                    <template slot-scope="scope">
                    <span class="td-copy" @click="copyClick(scope.row.inventoryPaymentActualNightFee)">{{ scope.row.inventoryPaymentActualNightFee }}</span>
                </template>
                </el-table-column>
            </el-table-column>
            <el-table-column label="利差">
                <el-table-column prop="inventoryAccountPlanProfitRate" label="费率">
                    <template slot-scope="scope">
                    <span class="td-copy" @click="copyClick(scope.row.inventoryAccountPlanProfitRate)">{{ scope.row.inventoryAccountPlanProfitRate }}</span>
                </template>
                </el-table-column>
                <el-table-column prop="inventoryPaymentActualProfitFee" label="利差">
                    <template slot-scope="scope">
                    <span class="td-copy" @click="copyClick(scope.row.inventoryPaymentActualProfitFee)">{{ scope.row.inventoryPaymentActualProfitFee }}</span>
                </template>
                </el-table-column>
            </el-table-column>
            <el-table-column prop="inventoryPaymentPlanFeeFinance" label="财务费">
                <template slot-scope="scope">
                    <span class="td-copy" @click="copyClick(scope.row.inventoryPaymentPlanFeeFinance)">{{ scope.row.inventoryPaymentPlanFeeFinance }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="inventoryPaymentActualServiceTotal" label="服务费">
                <template slot-scope="scope">
                    <span class="td-copy" @click="copyClick(scope.row.inventoryPaymentActualServiceTotal)">{{ scope.row.inventoryPaymentActualServiceTotal }}</span>
                </template>
            </el-table-column>
            <el-table-column prop="inventoryPaymentActualFeeTotal" label="总费用">
                <template slot-scope="scope">
                    <span class="td-copy" @click="copyClick(scope.row.inventoryPaymentActualFeeTotal)">{{ scope.row.inventoryPaymentActualFeeTotal }}</span>
                </template>
            </el-table-column>
            <!-- 预付 -->
            <el-table-column prop="inventoryPaymentActualPay" label="预付">
                <template slot-scope="scope">
                    <span class="td-copy" @click="copyClick(scope.row.inventoryPaymentActualPay)">{{ scope.row.inventoryPaymentActualPay }}</span>
                </template>
            </el-table-column>
            <!-- 剩余 -->
            <el-table-column prop="inventoryPaymentActualUnpay" label="剩余">
                <template slot-scope="scope">
                    <span class="td-copy" @click="copyClick(scope.row.inventoryPaymentActualUnpay)">{{ scope.row.inventoryPaymentActualUnpay }}</span>
                </template>
            </el-table-column>
            <el-table-column label="状态" width="90">
                <template slot-scope="scope">
                    <el-tag v-if="scope.row.inventoryPaymentActualStatus != '-' && scope.row.inventoryPaymentActualStatus == 1" type="success">已结账</el-tag>
                    <el-tag v-if="scope.row.inventoryPaymentActualStatus != '-' && scope.row.inventoryPaymentActualStatus == 0" type="error">未结账</el-tag>
                    <span v-if="scope.row.inventoryPaymentActualStatus == '-'">-</span>
                </template>
            </el-table-column>
            <!-- 操作栏 -->
            <el-table-column label="操作" width="60" fixed="right">
                <template slot-scope="scope">
                    <div v-if="scope.row.inventoryCustomerName != '合计'">
                        <el-button @click="handleClick('update', scope.row, 'base')" type="text" size="small"
                            v-if="pageMap.handle.update && checkPermissionButton('编辑')">编辑</el-button>
                    </div>
                    <div v-else>-</div>
                </template>
            </el-table-column>
        </el-table>
        <div v-if="total > 0" class="page-wrapper">
            <el-pagination @size-change="sizeChange" @current-change="currentChange" :current-page="current"
                :page-sizes="[10, 20, 30, 40, 1000]" :page-size="size" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
        <el-dialog :title="getModalTitle()" :visible.sync="isHandle" width="40%" :close-on-click-modal="false">
            <div v-if="handle == 'insert' || handle == 'update'">
                <el-form ref="form" :model="handleInfo" label-width="100px">
                    <!-- 实际费用 -->
                    <!-- <el-form-item label="开票金额">
                        <el-input v-model="handleInfo.inventoryPaymentActualTradeAmount"></el-input>
                    </el-form-item> -->
                    <!-- <el-form-item label="利差">
                        <el-input v-model="handleInfo.inventoryPaymentActualTradeFee"></el-input>
                    </el-form-item> -->
                    <!-- <el-form-item label="过夜金额">
                        <el-input v-model="handleInfo.inventoryPaymentActualNightAmount"></el-input>
                    </el-form-item> -->
                    <!-- <el-form-item label="财务费">
                        <el-input v-model="handleInfo.inventoryPaymentActualFeeFinance"></el-input>
                    </el-form-item> -->
                    <el-form-item label="预付">
                        <el-input v-model="handleInfo.inventoryPaymentActualPay"></el-input>
                    </el-form-item>
                    <el-form-item label="台账状态">
                        <el-select v-model="handleInfo.inventoryPaymentActualStatus" placeholder="请选择" style="width: 100%;">
                            <el-option label="已结账" :value="1"></el-option>
                            <el-option label="未结账" :value="0"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <div v-if="handle == 'delete'">您确认要删除吗？删除后将不可恢复！</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isHandle = false">取 消</el-button>
                <el-button type="primary" @click="handleSubmit()">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 导出弹窗 -->
        <el-dialog title="选择导出设置" :visible.sync="isExport" width="30%">
            <el-checkbox-group v-model="exportChecked">
                <el-checkbox :label="item.name" v-for="item in exportMap"></el-checkbox>
            </el-checkbox-group>
            <span slot="footer" class="dialog-footer">
                <el-button @click="isExport = false">取 消</el-button>
                <el-button type="primary" @click="exportConfirm()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import verifyMixin from "@/mixins/verify-mixin.js"
import listMixin from "@/mixins/list-mixin.js"

import { API, doGet } from "@/api/api.js"

export default {
    mixins: [verifyMixin, listMixin],
    data: function () {
        return {
            type: "",
            customers: [],
            monthRange: [],
        }
    },
    methods: {
        monthRangeChange: function(e) {
            this.filterParams.inventory_common_month_start = e[0];
            this.filterParams.inventory_common_month_end = e[1];
            this.loadData(1);
        },
        getCustomers: async function () {
            this.customers = await doGet("/inventoryCustomer" + API.ALL);
        },
        beforeHandleOpenEx: function (handle, info, type) {
            this.type = type;
            if (handle == "update") {
                this.handleInfo.type = type;
            }
        },
        afterInitialData: function () {
            if (this.records && this.records.length > 0) {
                let inventoryAccountActualTradeAmount = 0;
                let inventoryPaymentPlanTradeFee = 0;
                let inventoryPaymentPlanNightFee = 0;
                let inventoryPaymentPlanProfitFee = 0;
                let inventoryPaymentActualServiceTotal = 0;
                let inventoryPaymentPlanFeeFinance = 0;
                let inventoryPaymentPlanFeeService = 0;
                let inventoryPaymentPlanFeeTotal = 0;
                let inventoryPaymentActualTradeAmount = 0;
                let inventoryPaymentActualTradeService = 0;
                let inventoryPaymentActualTradeFee = 0;
                let inventoryPaymentActualNightAmount = 0;
                let inventoryPaymentActualNightFee = 0;
                let inventoryPaymentActualFeeFinance = 0;
                let inventoryPaymentActualFeeTotal = 0;
                let inventoryPaymentActualProfitFee = 0;
                let inventoryPaymentActualPay = 0;
                let inventoryPaymentActualUnpay = 0;
                for (let i = 0; i < this.records.length; i++) {
                    inventoryAccountActualTradeAmount += this.records[i].inventoryAccountActualTradeAmount;
                    inventoryPaymentPlanTradeFee += this.records[i].inventoryPaymentPlanTradeFee;
                    inventoryPaymentPlanNightFee += this.records[i].inventoryPaymentPlanNightFee;
                    inventoryPaymentPlanProfitFee += this.records[i].inventoryPaymentPlanProfitFee;
                    inventoryPaymentActualServiceTotal += this.records[i].inventoryPaymentActualServiceTotal;
                    inventoryPaymentPlanFeeFinance += this.records[i].inventoryPaymentPlanFeeFinance;
                    inventoryPaymentPlanFeeService += this.records[i].inventoryPaymentPlanFeeService;
                    inventoryPaymentPlanFeeTotal += this.records[i].inventoryPaymentPlanFeeTotal;
                    inventoryPaymentActualTradeAmount += this.records[i].inventoryPaymentActualTradeAmount;
                    inventoryPaymentActualTradeService += this.records[i].inventoryPaymentActualTradeService;
                    inventoryPaymentActualTradeFee += this.records[i].inventoryPaymentActualTradeFee;
                    inventoryPaymentActualNightAmount += this.records[i].inventoryPaymentActualNightAmount;
                    inventoryPaymentActualNightFee += this.records[i].inventoryPaymentActualNightFee;
                    inventoryPaymentActualFeeFinance += this.records[i].inventoryPaymentActualFeeFinance;
                    inventoryPaymentActualFeeTotal += this.records[i].inventoryPaymentActualFeeTotal;
                    inventoryPaymentActualPay += this.records[i].inventoryPaymentActualPay;
                    inventoryPaymentActualUnpay += this.records[i].inventoryPaymentActualUnpay;
                    inventoryPaymentActualProfitFee += this.records[i].inventoryPaymentActualProfitFee;
                }
                this.records.push({
                    inventoryCustomerName: '合计',
                    inventoryCustomerPerson: '-',
                    inventoryPaymentMonth: '-',
                    inventoryAccountActualTradeAmount: inventoryAccountActualTradeAmount.toFixed(1),
                    inventoryPaymentPlanTradeRate: '-',
                    inventoryPaymentPlanTradeFee: inventoryPaymentPlanTradeFee.toFixed(1),
                    inventoryPaymentPlanNightPercent: '-',
                    inventoryPaymentPlanNightRate: '-',
                    inventoryPaymentPlanNightFee: inventoryPaymentPlanNightFee.toFixed(1),
                    inventoryPaymentPlanProfitPercent: '-',
                    inventoryPaymentPlanProfitFee: inventoryPaymentPlanProfitFee.toFixed(1),
                    inventoryPaymentPlanFeeFinance: inventoryPaymentPlanFeeFinance.toFixed(1),
                    inventoryPaymentActualServiceTotal: inventoryPaymentActualServiceTotal.toFixed(1),
                    inventoryPaymentPlanFeeService: inventoryPaymentPlanFeeService.toFixed(1),
                    inventoryPaymentPlanFeeTotal: inventoryPaymentPlanFeeTotal.toFixed(1),
                    inventoryPaymentActualTradeAmount: inventoryPaymentActualTradeAmount.toFixed(1),
                    inventoryPaymentActualTradeService: inventoryPaymentActualTradeService.toFixed(1),
                    inventoryPaymentActualTradeFee: inventoryPaymentActualTradeFee.toFixed(1),
                    inventoryPaymentActualNightAmount: inventoryPaymentActualNightAmount.toFixed(1),
                    inventoryPaymentActualNightFee: inventoryPaymentActualNightFee.toFixed(1),
                    inventoryPaymentActualFeeFinance: inventoryPaymentActualFeeFinance.toFixed(1),
                    inventoryPaymentActualFeeTotal: inventoryPaymentActualFeeTotal.toFixed(1),
                    inventoryPaymentActualPay: inventoryPaymentActualPay.toFixed(1),
                    inventoryPaymentActualUnpay: inventoryPaymentActualUnpay.toFixed(1),
                    inventoryPaymentActualProfitFee: inventoryPaymentActualProfitFee.toFixed(1)
                });
            }
        }
    },
    created: function () {
        this.tag = "inventoryPayment";
        this.getCustomers();
        this.exportMap = [
            //COMMON
            { name: "月份", value: "inventoryCommonMonth", checked: true }, 
            { name: "公司名称", value: "inventoryCustomerName", checked: true }, 
            { name: "负责人", value: "inventoryCustomerPerson", checked: true }, 
            { name: "项目", value: "inventoryCategoryName", checked: true }, 
            //下游实际
            { name: "实际开票金额", value: "inventoryAccountActualTradeAmount", checked: true }, 
            { name: "下游实际服务费", value: "inventoryPaymentActualTradeService", checked: true }, 
            { name: "下游实际利差费率", value: "inventoryAccountPlanProfitRate", checked: true }, 
            { name: "下游实际利差", value: "inventoryPaymentActualProfitFee", checked: true }, 
            { name: "下游实际过夜金额", value: "inventoryPaymentActualNightAmount", checked: true }, 
            { name: "下游实际过夜费", value: "inventoryPaymentActualNightFee", checked: true }, 
            { name: "下游财务费", value: "inventoryPaymentPlanFeeFinance", checked: true }, 
            { name: "服务费", value: "inventoryPaymentActualServiceTotal", checked: true }, 
            { name: "下游实际总费用", value: "inventoryPaymentActualFeeTotal", checked: true }, 
            { name: "下游实际预付", value: "inventoryPaymentActualPay", checked: true }, 
            { name: "下游实际剩余", value: "inventoryPaymentActualUnpay", checked: true }, 
        ];
    }
}
</script>
<style scoped lang="less">
@import "@/assets/style/list-style.less";
</style>